// import { useQuery } from "@tanstack/react-query";
// import Table from "../../ChildComponents/Table";
// import { MdEditDocument } from "react-icons/md";
// import {
//   FaFacebook,
//   FaYoutube,
//   FaTwitter,
//   FaInstagram,
//   FaGooglePlay,
//   FaApple,
//   FaNewspaper,
//   FaInfoCircle,
//   FaMapMarkerAlt,
//   FaShareAlt,
//   FaPhoneAlt,
//   FaEnvelope,
// } from "react-icons/fa";

// import { useGetInfo } from "../../store/api/generalSettingApi";
// const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;

// function GenerelSettingList({ onEdit }) {
//   const getInfo = useGetInfo();
//   const {
//     data: Data,
//     isLoading: isLoading,
//     error: error,
//   } = useQuery({ queryKey: "genarel-seeting", queryFn: getInfo });

//   const data = Data?.data;

//   function stripHtmlTags(html) {
//     if (!html) return "";
//     return html.replace(/<[^>]*>?/gm, "");
//   }

//   if (isLoading) {
//     return <div className="my-5 text-center fw-bold">Loading...</div>;
//   }

//   // Handle error state
//   if (error) {
//     return (
//       <div className="my-5 text-center fw-bold text-danger">
//         Error: {error.message}
//       </div>
//     );
//   }

//   return (
//     <div className="container my-5">
//       <div className="d-flex justify-content-end mb-3">
//         <button
//           onClick={() => onEdit(data)}
//           className="btn btn-warning text-white fs-4 mx-2"
//           aria-label="Edit Document"
//           type="button"
//         >
//           <MdEditDocument />
//         </button>
//       </div>

//       <div className="card shadow rounded-4 p-4 border-0">
//         {/* Logo and Heading */}
//         <div className="d-flex align-items-center mb-4 border-bottom pb-3">
//           <img
//             src={`${IMAGE_URL}/${data?.logo}`} // Adjust path
//             alt="Logo"
//             className="me-4"
//             style={{
//               width: "90px",
//               height: "90px",
//               objectFit: "contain",
//               borderRadius: "12px",
//             }}
//           />
//           <div>
//             <h2 className="fw-bold mb-1">{data?.websiteName}</h2>
//             <p className="text-muted fst-italic mb-0">
//               <FaInfoCircle className="text-primary me-2" /> {data?.tagLine}
//             </p>
//           </div>
//         </div>

//         {/* Info Rows */}
//         <div className="row gy-3 mb-4">
//           <div className="col-md-6">
//             <p>
//               <strong>Title:</strong> {data?.websiteTitle}
//             </p>
//             <p>
//               <FaEnvelope className="me-2 text-secondary" />
//               <a
//                 href={`mailto:${data?.email}`}
//                 className="text-decoration-none"
//               >
//                 {data?.email}
//               </a>
//             </p>
//             <p>
//               <FaPhoneAlt className="me-2 text-secondary" /> {data?.phone}
//             </p>
//             <p>
//               <FaPhoneAlt className="me-2 text-secondary" /> {data?.mobile}
//             </p>
//           </div>
//           <div className="col-md-6">
//             <p>
//               <FaMapMarkerAlt className="me-2 text-danger" /> {data?.address}
//             </p>
//             <p>
//               <strong>Meta Description:</strong>{" "}
//               {stripHtmlTags(data?.metaDescription)}
//             </p>
//             <p>
//               <strong>Created:</strong>{" "}
//               {new Date(data?.createdAt).toLocaleString()}
//             </p>
//             <p>
//               <strong>Updated:</strong>{" "}
//               {new Date(data?.updatedAt).toLocaleString()}
//             </p>
//           </div>
//         </div>

//         {/* Social Media */}
//         <div className="border-top pt-3 mb-4">
//           <h5 className="fw-semibold mb-3">
//             <FaShareAlt className="me-2 text-primary" /> Social Media
//           </h5>
//           <div className="d-flex flex-wrap gap-3">
//             <a
//               href={`https://${data?.facebook}`}
//               className="btn btn-outline-primary btn-sm"
//               target="_blank"
//               rel="noreferrer"
//             >
//               <FaFacebook className="me-1" /> Facebook
//             </a>
//             <a
//               href={`https://${data?.youtube}`}
//               className="btn btn-outline-danger btn-sm"
//               target="_blank"
//               rel="noreferrer"
//             >
//               <FaYoutube className="me-1" /> YouTube
//             </a>
//             <a
//               href={data?.twitterX}
//               className="btn btn-outline-info btn-sm"
//               target="_blank"
//               rel="noreferrer"
//             >
//               <FaTwitter className="me-1" /> Twitter
//             </a>
//             <a
//               href={data?.instagram}
//               className="btn btn-outline-warning btn-sm text-dark"
//               target="_blank"
//               rel="noreferrer"
//             >
//               <FaInstagram className="me-1" /> Instagram
//             </a>
//           </div>
//         </div>

//         {/* Apps & News */}
//         <div className="border-top pt-3">
//           <h5 className="fw-semibold mb-3">
//             <FaShareAlt className="me-2 text-success" /> Apps & News
//           </h5>
//           <div className="d-flex flex-wrap gap-3">
//             <a
//               href={data?.playStore}
//               className="btn btn-success btn-sm"
//               target="_blank"
//               rel="noreferrer"
//             >
//               <FaGooglePlay className="me-1" /> Play Store
//             </a>
//             <a
//               href={data?.appsStore}
//               className="btn btn-dark btn-sm"
//               target="_blank"
//               rel="noreferrer"
//             >
//               <FaApple className="me-1" /> App Store
//             </a>
//             <a
//               href={data?.googleNews}
//               className="btn btn-secondary btn-sm"
//               target="_blank"
//               rel="noreferrer"
//             >
//               <FaNewspaper className="me-1" /> Google News
//             </a>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default GenerelSettingList;

import { useQuery } from "@tanstack/react-query";
import { MdEditDocument } from "react-icons/md";
import {
  FaFacebook,
  FaYoutube,
  FaTwitter,
  FaInstagram,
  FaGooglePlay,
  FaApple,
  FaNewspaper,
  FaLinkedin,
  FaWhatsapp,
} from "react-icons/fa";

import { useGetInfo } from "../../store/api/generalSettingApi";
const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;

function GenerelSettingList({ onEdit }) {
  const getInfo = useGetInfo();
  const {
    data: Data,
    isLoading: isLoading,
    error: error,
  } = useQuery({ queryKey: "genarel-seeting", queryFn: getInfo });

  const data = Data?.data;

  function stripHtmlTags(html) {
    if (!html) return "";
    return html.replace(/<[^>]*>?/gm, "");
  }

  if (isLoading) {
    return (
      <div className="modern-settings-list">
        <style>{`
          .modern-settings-list {
            min-height: 100vh;
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
            padding: 2rem;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .loading-spinner-settings {
            width: 60px;
            height: 60px;
            border: 4px solid #e9ecef;
            border-top: 4px solid #667eea;
            border-radius: 50%;
            animation: spin 1s linear infinite;
          }

          @keyframes spin {
            to { transform: rotate(360deg); }
          }

          .loading-text-settings {
            margin-top: 1.5rem;
            font-size: 1.125rem;
            font-weight: 600;
            color: #718096;
          }
        `}</style>
        <div style={{ textAlign: "center" }}>
          <div className="loading-spinner-settings"></div>
          <p className="loading-text-settings">Loading Settings...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="modern-settings-list">
        <div style={{ textAlign: "center" }}>
          <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>⚠️</div>
          <h4 style={{ color: "#e53e3e", fontWeight: "700" }}>
            Error Loading Settings
          </h4>
          <p style={{ color: "#718096" }}>{error.message}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="modern-settings-list">
      <style>{`
        .modern-settings-list {
          min-height: 100vh;
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
          padding: 2rem;
        }

        .settings-header-bar {
          background: white;
          padding: 1.5rem 2rem;
          border-radius: 20px;
          margin-bottom: 2rem;
          box-shadow: 0 2px 20px rgba(0,0,0,0.03);
          border: 1px solid #e9ecef;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .settings-page-title {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          font-size: 1.75rem;
          font-weight: 800;
          margin: 0;
          display: flex;
          align-items: center;
          gap: 0.75rem;
        }

        .edit-btn-modern {
          padding: 0.75rem 1.5rem;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border: none;
          border-radius: 14px;
          color: white;
          font-weight: 700;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-size: 1rem;
        }

        .edit-btn-modern:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
        }

        .main-info-card {
          background: white;
          border-radius: 24px;
          padding: 2.5rem;
          margin-bottom: 2rem;
          box-shadow: 0 4px 30px rgba(0,0,0,0.05);
          border: 1px solid #e9ecef;
          position: relative;
          overflow: hidden;
        }

        .main-info-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 5px;
          background: linear-gradient(90deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
        }

        .logo-header-section {
          display: flex;
          align-items: center;
          gap: 2rem;
          padding-bottom: 2rem;
          border-bottom: 2px solid #f0f0f0;
          margin-bottom: 2rem;
        }

        .logo-wrapper {
          position: relative;
          width: 100px;
          height: 100px;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 8px 25px rgba(0,0,0,0.1);
          border: 3px solid white;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .logo-wrapper img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          background: white;
        }

        .website-title-section h1 {
          font-size: 2rem;
          font-weight: 800;
          color: #2d3748;
          margin: 0 0 0.5rem 0;
        }

        .tagline-text {
          color: #718096;
          font-size: 1.125rem;
          margin: 0;
          font-style: italic;
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .info-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 2rem;
          margin-bottom: 2rem;
        }

        .info-item {
          display: flex;
          align-items: start;
          gap: 1rem;
          padding: 1rem;
          background: #f8f9fa;
          border-radius: 14px;
          transition: all 0.3s ease;
        }

        .info-item:hover {
          background: #e9ecef;
          transform: translateX(5px);
        }

        .info-icon {
          width: 40px;
          height: 40px;
          min-width: 40px;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 1.125rem;
        }

        .info-content h6 {
          font-size: 0.8rem;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          color: #a0aec0;
          margin: 0 0 0.25rem 0;
          font-weight: 700;
        }

        .info-content p {
          margin: 0;
          color: #2d3748;
          font-weight: 600;
          font-size: 1rem;
          word-break: break-word;
        }

        .info-content a {
          color: #667eea;
          text-decoration: none;
          font-weight: 600;
        }

        .info-content a:hover {
          text-decoration: underline;
        }

        .section-card {
          background: white;
          border-radius: 20px;
          padding: 2rem;
          margin-bottom: 1.5rem;
          box-shadow: 0 2px 20px rgba(0,0,0,0.03);
          border: 1px solid #e9ecef;
        }

        .section-card-header {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          margin-bottom: 1.5rem;
          padding-bottom: 1rem;
          border-bottom: 2px solid #f0f0f0;
        }

        .section-icon-wrapper {
          width: 40px;
          height: 40px;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 1.125rem;
          box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
        }

        .section-title {
          font-size: 1.25rem;
          font-weight: 700;
          color: #2d3748;
          margin: 0;
        }

        .social-links-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
          gap: 1rem;
        }

        .social-link-btn {
          padding: 1rem;
          border: 2px solid #e9ecef;
          background: white;
          border-radius: 14px;
          text-decoration: none;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.5rem;
          font-weight: 700;
          font-size: 0.95rem;
          transition: all 0.3s ease;
          color: #4a5568;
        }

        .social-link-btn:hover {
          transform: translateY(-4px);
          box-shadow: 0 6px 20px rgba(0,0,0,0.1);
        }

        .social-link-btn.facebook:hover {
          background: #1877f2;
          color: white;
          border-color: #1877f2;
        }

        .social-link-btn.youtube:hover {
          background: #ff0000;
          color: white;
          border-color: #ff0000;
        }

        .social-link-btn.twitter:hover {
          background: #1da1f2;
          color: white;
          border-color: #1da1f2;
        }

        .social-link-btn.instagram:hover {
          background: linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%);
          color: white;
          border-color: transparent;
        }

        .social-link-btn.linkedin:hover {
          background: #0077b5;
          color: white;
          border-color: #0077b5;
        }

        .social-link-btn.whatsapp:hover {
          background: #25d366;
          color: white;
          border-color: #25d366;
        }

        .social-link-btn.playstore:hover {
          background: #34a853;
          color: white;
          border-color: #34a853;
        }

        .social-link-btn.appstore:hover {
          background: #000000;
          color: white;
          border-color: #000000;
        }

        .social-link-btn.googlenews:hover {
          background: #4285f4;
          color: white;
          border-color: #4285f4;
        }

        .meta-description-box {
          background: #f8f9fa;
          padding: 1.5rem;
          border-radius: 14px;
          border-left: 4px solid #667eea;
          margin-top: 1rem;
        }

        .meta-description-box h6 {
          font-size: 0.8rem;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          color: #a0aec0;
          margin: 0 0 0.75rem 0;
          font-weight: 700;
        }

        .meta-description-box p {
          margin: 0;
          color: #4a5568;
          line-height: 1.6;
        }

        .timestamps-row {
          display: flex;
          gap: 2rem;
          margin-top: 1.5rem;
          padding-top: 1.5rem;
          border-top: 2px solid #f0f0f0;
        }

        .timestamp-item {
          flex: 1;
          text-align: center;
          padding: 1rem;
          background: #f8f9fa;
          border-radius: 14px;
        }

        .timestamp-item h6 {
          font-size: 0.75rem;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          color: #a0aec0;
          margin: 0 0 0.5rem 0;
          font-weight: 700;
        }

        .timestamp-item p {
          margin: 0;
          color: #2d3748;
          font-weight: 600;
          font-size: 0.9rem;
        }

        @media (max-width: 768px) {
          .modern-settings-list {
            padding: 1rem;
          }

          .settings-header-bar {
            flex-direction: column;
            gap: 1rem;
            padding: 1.5rem;
          }

          .main-info-card {
            padding: 1.5rem;
          }

          .logo-header-section {
            flex-direction: column;
            text-align: center;
          }

          .website-title-section h1 {
            font-size: 1.5rem;
          }

          .info-grid {
            grid-template-columns: 1fr;
          }

          .social-links-grid {
            grid-template-columns: 1fr;
          }

          .timestamps-row {
            flex-direction: column;
            gap: 1rem;
          }
        }
      `}</style>

      {/* Header with Edit Button */}
      <div className="settings-header-bar">
        <h1 className="settings-page-title">⚙️ General Settings</h1>
        <button
          onClick={() => onEdit(data)}
          className="edit-btn-modern"
          type="button"
        >
          <MdEditDocument size={20} />
          Edit Settings
        </button>
      </div>

      {/* Main Information Card */}
      <div className="main-info-card">
        {/* Logo and Website Name */}
        <div className="logo-header-section">
          <div className="logo-wrapper">
            <img src={`${data?.logo}`} alt="Logo" />
          </div>
          <div className="website-title-section">
            <h1>{data?.websiteName}</h1>
            <p className="tagline-text">✨ {data?.tagLine}</p>
          </div>
        </div>

        {/* Contact Information Grid */}
        <div className="info-grid">
          <div className="info-item">
            <div className="info-icon">📧</div>
            <div className="info-content">
              <h6>Email</h6>
              <p>
                <a href={`mailto:${data?.email}`}>{data?.email}</a>
              </p>
            </div>
          </div>

          <div className="info-item">
            <div className="info-icon">📞</div>
            <div className="info-content">
              <h6>Phone</h6>
              <p>{data?.phone}</p>
            </div>
          </div>

          <div className="info-item">
            <div className="info-icon">📱</div>
            <div className="info-content">
              <h6>Mobile</h6>
              <p>{data?.mobile}</p>
            </div>
          </div>

          <div className="info-item">
            <div className="info-icon">📍</div>
            <div className="info-content">
              <h6>Address</h6>
              <p>{data?.address}</p>
            </div>
          </div>

          <div className="info-item">
            <div className="info-icon">🏷️</div>
            <div className="info-content">
              <h6>Website Title</h6>
              <p>{data?.websiteTitle}</p>
            </div>
          </div>
        </div>

        {/* Meta Description */}
        {data?.metaDescription && (
          <div className="meta-description-box">
            <h6>Meta Description</h6>
            <p>{stripHtmlTags(data?.metaDescription)}</p>
          </div>
        )}

        {/* Timestamps */}
        <div className="timestamps-row">
          <div className="timestamp-item">
            <h6>Created</h6>
            <p>
              {new Date(data?.createdAt).toLocaleDateString("en-US", {
                day: "numeric",
                month: "short",
                year: "numeric",
              })}
            </p>
          </div>
          <div className="timestamp-item">
            <h6>Last Updated</h6>
            <p>
              {new Date(data?.updatedAt).toLocaleDateString("en-US", {
                day: "numeric",
                month: "short",
                year: "numeric",
              })}
            </p>
          </div>
        </div>
      </div>

      {/* Social Media Section */}
      <div className="section-card">
        <div className="section-card-header">
          <div className="section-icon-wrapper">🔗</div>
          <h2 className="section-title">Social Media Links</h2>
        </div>
        <div className="social-links-grid">
          {data?.facebook && (
            <a
              href={`https://${data?.facebook}`}
              className="social-link-btn facebook"
              target="_blank"
              rel="noreferrer"
            >
              <FaFacebook size={18} />
              Facebook
            </a>
          )}
          {data?.youtube && (
            <a
              href={`https://${data?.youtube}`}
              className="social-link-btn youtube"
              target="_blank"
              rel="noreferrer"
            >
              <FaYoutube size={18} />
              YouTube
            </a>
          )}
          {data?.twitterX && (
            <a
              href={data?.twitterX}
              className="social-link-btn twitter"
              target="_blank"
              rel="noreferrer"
            >
              <FaTwitter size={18} />
              Twitter
            </a>
          )}
          {data?.instagram && (
            <a
              href={data?.instagram}
              className="social-link-btn instagram"
              target="_blank"
              rel="noreferrer"
            >
              <FaInstagram size={18} />
              Instagram
            </a>
          )}
          {data?.linkedIn && (
            <a
              href={data?.linkedIn}
              className="social-link-btn linkedin"
              target="_blank"
              rel="noreferrer"
            >
              <FaLinkedin size={18} />
              LinkedIn
            </a>
          )}
          {data?.whatsapps && (
            <a
              href={`https://wa.me/${data?.whatsapps}`}
              className="social-link-btn whatsapp"
              target="_blank"
              rel="noreferrer"
            >
              <FaWhatsapp size={18} />
              WhatsApp
            </a>
          )}
        </div>
      </div>

      {/* Apps & News Section */}
      <div className="section-card">
        <div className="section-card-header">
          <div className="section-icon-wrapper">📱</div>
          <h2 className="section-title">Apps & News</h2>
        </div>
        <div className="social-links-grid">
          {data?.playStore && (
            <a
              href={data?.playStore}
              className="social-link-btn playstore"
              target="_blank"
              rel="noreferrer"
            >
              <FaGooglePlay size={18} />
              Play Store
            </a>
          )}
          {data?.appsStore && (
            <a
              href={data?.appsStore}
              className="social-link-btn appstore"
              target="_blank"
              rel="noreferrer"
            >
              <FaApple size={18} />
              App Store
            </a>
          )}
          {data?.googleNews && (
            <a
              href={data?.googleNews}
              className="social-link-btn googlenews"
              target="_blank"
              rel="noreferrer"
            >
              <FaNewspaper size={18} />
              Google News
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

export default GenerelSettingList;
